// @flow

import {useSelector} from 'react-redux';
import type {RootState} from '../..';
import {useActions} from '../../../utils/globalStore';
import type {UserType} from '../../../entities';

import {actions as AuthActions} from '../duck';

const ALLOWED_AUTH_TOKENS = ['s_u_token', 'd_c_token', 'w_m_token'];

export const getAuthDefaultToken = (queryObject: {[key: string]: any}) => {
  const tokenKey = ALLOWED_AUTH_TOKENS.find(
    tKey => typeof queryObject[tKey] === 'string'
  );
  if (tokenKey) return queryObject[tokenKey];
};

const userSelector = (state: RootState) => state.auth.user;

export function useUser() {
  const user = useSelector(userSelector);

  return user;
}

export function useUserType(): {
  isVendor: boolean,
  isCollaborator: boolean,
  userId: string,
  userType?: UserType,
} {
  const user = useUser();

  if (!user) {
    return {
      isCollaborator: false,
      isVendor: false,
      userId: '',
    };
  }

  const isCollaborator = user.type === 'collaborator-user';
  const isVendor = user.type === 'vendor-user';

  return {
    isCollaborator,
    isVendor,
    userId: user.id,
    userType: user.type,
  };
}

export function useAuthSession() {
  const refreshSession = useActions(AuthActions.getSession);
  return {
    refreshSession,
  };
}

export function useAuth() {
  const user = useUser();
  const logout = useActions(AuthActions.logout);
  const login = useActions(AuthActions.login);
  const refreshSession = useActions(AuthActions.refreshSession);

  return {
    user,
    logout,
    login,
    refreshSession,
  };
}
